// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const GridApi = t.struct({
    dateFields: t.list(t.String)
});

export const getDefaultState = () =>
    new GridApi({
        dateFields: [
            'actualAuditDate',
            'auditPlannedDate'
        ]
    });

export default GridApi;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/state/grid-api.js